import { firstPersonalBook } from '@/onboarding'

export default async (commit, settings) => {
  try {
    await firstPersonalBook(commit, settings)

    return Promise.resolve()
  } catch (err) {
    commit('loading', false)
    return Promise.reject(err)
  }
}
